module.exports = __webpack_public_path__ + "static/media/about-img-8@2x.1f5928f8.png";